import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Icon, Message } from 'semantic-ui-react';

import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

// The walk-in gate, seen from the booking form (MS-6631, for MS-6625's rule). The decision —
// whether to say anything at all — is walkInNoticeFor in utils/crmConfig, where it can be tested
// against every combination of tenant, user and session; this only says it. Shown before the
// salesperson types anything, because the alternative is forty fields and then a 422.
const ns = { ns: TRANSLATION_FILES.translation };

export function CrmWalkInNotice({ notice, t }) {
  if (!notice) return null;
  return (
    <Message size="mini" info icon data-testid="crm-walkin-notice" data-provider={notice.provider}>
      <Icon name="linkify" />
      <Message.Content>
        {t(
          'Bookings by internal staff start from {{crm}}. Open the customer\'s lead in {{crm}} and use its booking link; a booking entered here without one will be refused.',
          { ...ns, crm: notice.label },
        )}
      </Message.Content>
    </Message>
  );
}

CrmWalkInNotice.propTypes = {
  // null when there is nothing to say; { provider, label } otherwise (walkInNoticeFor)
  notice: PropTypes.shape({
    provider: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }),
  t: PropTypes.func.isRequired,
};

CrmWalkInNotice.defaultProps = {
  notice: null,
};

export default withTranslation(namespaces)(CrmWalkInNotice);



// WEBPACK FOOTER //
// ./src/components/Crm/CrmWalkInNotice.jsx